// extracted by mini-css-extract-plugin
module.exports = {"colorBlack":"#000000","colorRed":"#b71c1c"};